import { motion } from "framer-motion";
import RevealLine from "./RevealLine";
import { DISTRICT_URL } from "@/lib/links";

const Footer = () => (
  <footer data-testid="footer" className="relative bg-night px-5 sm:px-10 pt-24 sm:pt-32 pb-28 sm:pb-12">
    <div className="mx-auto max-w-5xl text-center">
      <h2 className="font-display font-bold uppercase leading-[1.02] tracking-tight text-3xl sm:text-5xl lg:text-6xl text-bone">
        <RevealLine inView>Don't watch it</RevealLine>
        <RevealLine inView delay={0.12} className="text-coral">on stories.</RevealLine>
      </h2>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8, delay: 0.3 }}
        className="mt-10"
      >
        <a
          id="final-cta"
          data-testid="closing-district-ticket-button"
          href={DISTRICT_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="btn-ticket w-full sm:w-auto px-12 py-5 text-base sm:text-lg"
        >
          Get Tickets
        </a>
      </motion.div>
    </div>

    <div className="mx-auto max-w-5xl mt-24 sm:mt-32 pt-6 border-t border-bone/10 flex flex-col sm:flex-row sm:items-center justify-between gap-3 font-mono text-[10px] uppercase tracking-[0.25em] text-ash">
      <span data-testid="footer-copyright">© 2026 HUGEL India Tour</span>
      <span data-testid="footer-legal">Valid government ID required · Rights of admission reserved</span>
    </div>
  </footer>
);

export default Footer;
